import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Plant } from './models/Plant';

@Injectable({
  providedIn: 'root'
})
export class PlantService {
  private readonly http = inject(HttpClient);

  getPlants(dealerId: string): Observable<Plant[]> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getPlants}`;
    return this.http.get<{ data: Plant[] }>(url, { headers: { dealerId } }).pipe(map((response) => response.data));
  }
}
